export default __webpack_public_path__ + "static/media/event1.7c4a4b58.jpg";